export const mapCabinetToDomain = {
  webmaster: 'webmaster',
  advert: 'advert',
  dsp: 'dsp-partner',
};
